<template>
  <div class="new-criterio-content">
    <div class="title-criterio-details">{{ title }}</div>
    <v-card class="new-criterio" elevation="0" :disabled="disabled">
      <v-card-text>
        <v-tabs v-model="tabIndex" background-color="transparent" hide-slider grow class="tabs-menu">
          <v-tab v-for="tab in criterias.children" :key="tab.id" class="tab-container" @change="changeTab(tab.children)">
            {{ tab.label }}
            <news-badge v-if="isNewSegmentCriterias(tab.label)" class="pl-1" />
          </v-tab>
        </v-tabs>
        <div class="segmentation-criteria-group">
          <v-tabs-items v-for="group in groups" :key="group.id">
            <p class="group-title">{{ group.label }}</p>
            <div v-for="(criterio, index) in group.children" :key="index" class="criterio-template">
              <new-criterio-card
                v-if="!criterio.hidden"
                :criterio="criterio"
                :group="group"
                :index="index"
                :tab-index="tabIndex"
                :criterias="criterias"
                :segmentation-groups="segmentationGroups.groups"
                :dragged-object="draggedObject"
                :is-new-segment-criterias="isNewSegmentCriterias"
                @click-criteria="clickedCriteria = $event"
                @dragstart="drag"
                @dragend="dragEnd"
                @add-criteria="addCriteriaOnGroup"
              />
            </div>
          </v-tabs-items>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { isNewSegmentCriterias } from '@/helpers/news.js'

import { leftBranch } from '@/helpers/segmentationTree'
import cloneDeep from 'lodash/cloneDeep'
export default {
  components: {
    NewsBadge: () => import('@/components/NewsBadge.vue'),
    NewCriterioCard: () => import('./NewCriterioCard.vue'),
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Critérios da Segmentação',
    },
  },
  data: () => ({
    localGroups: [],
    group: null,
    clickedCriteria: null,
  }),
  computed: {
    ...mapState({
      draggedObject: (state) => state.segmentation.draggedObject,
      selectedCondition: (state) => state.segmentation.selectedCondition,
      criterias: (state) => state.segmentation.segmentation,
      segmentationGroups: (state) => state.segmentation.segmentationGroups,
      segmentationTabIndex: (state) => state.segmentation.segmentationTabIndex,
    }),

    tabIndex: {
      get() {
        return this.segmentationTabIndex
      },
      set(value) {
        this.setSegmentationTabIndex(value)
      },
    },
    groups: {
      get() {
        return this.localGroups
          .filter((group) => !group.requires_pii_access || this.hasPiiAccess)
          .filter((group) => !group.hidden)
          .filter((group) => group.children?.filter((child) => !child.hidden).length > 0)
      },
      set(groups) {
        this.localGroups = groups
      },
    },
  },
  mounted() {
    this.groups = this.criterias.children[this.tabIndex].children
  },
  methods: {
    ...mapWaitingActions({
      setDraggedObject: 'set-dragged-object',
      setSelectedCriteria: 'set-selected-criteria',
      setSegmentationGroups: 'set-segmentation-groups',
      setSegmentationTabIndex: 'set-segmentation-tab-index',
    }),
    ...mapActions(['setPersistOriginalSize']),
    isNewSegmentCriterias,
    drag(criterio, group) {
      this.group = group
      const newLeftBranch = leftBranch(criterio.children[0]).map((node) => ({
        id: node.id,
        value: node.value,
      }))

      const newCriteriaValue = [{ id: this.criterias.children[this.tabIndex].id }, { id: group.id }, { id: criterio.id }]

      const draggedObject = { criteriaValue: newCriteriaValue.concat(newLeftBranch), new: true }

      this.setDraggedObject(draggedObject)
    },

    dragEnd() {
      this.group = null
      this.setDraggedObject({})
    },

    addCriteriaOnGroup(criterio, criteriaGroup, groupIndex) {
      this.group = criteriaGroup
      const newLeftBranch = leftBranch(criterio.children[0]).map((node) => ({
        id: node.id,
        value: node.value,
      }))

      const newCriteriaValue = [{ id: this.criterias.children[this.tabIndex].id }, { id: criteriaGroup.id }, { id: criterio.id }]

      const criterioToAdd = { criteriaValue: newCriteriaValue.concat(newLeftBranch), new: true }

      this.setSelectedCriteria({ ...criterioToAdd, groupIndex, criteriaIndex: this.getIndexToInsertCriteria(groupIndex) })

      this.insertCriteriaOnGroup(criterioToAdd.criteriaValue, groupIndex, this.getIndexToInsertCriteria(groupIndex))
    },

    getIndexToInsertCriteria(groupIndex) {
      const branch = this.segmentationGroups.groups[groupIndex]

      if (branch?.criteria?.length) return branch.criteria.length
      else return 0
    },

    insertCriteriaOnGroup(branch, groupIndex, criteriaIndex) {
      let segmentationGroups = cloneDeep(this.segmentationGroups)
      if (groupIndex >= segmentationGroups?.groups?.length) {
        segmentationGroups.groups[groupIndex] = {
          criteria: [],
          operator: 'AND',
        }
      }

      segmentationGroups.groups[groupIndex].criteria[criteriaIndex] = branch
      this.setSegmentationGroups(segmentationGroups)
      this.setPersistOriginalSize(false)
    },

    changeTab(groups) {
      this.groups = groups
    },
  },
}
</script>

<style lang="scss" scoped>
.new-criterio-content {
  .instructions-container {
    background-color: $marca-0-l30;
    border-radius: 10px;
    padding: 10px;
    margin: 0 20px !important;
    color: $branco;
    font-size: 14px;
    font-weight: bold;
    align-items: center;
  }

  .new-criterio {
    width: 100%;
    display: inline-flex;
    padding: 20px;
    border-radius: 8px;
    background: #ecedf0;

    .v-card__text {
      padding-top: 0;
    }

    .tabs-menu {
      border-bottom: 1px solid $cinza-l60;
    }
    .segmentation-criteria-group {
      height: 450px;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 0px 8px 0px 4px;

      ::v-deep .v-window__container {
        background-color: $cinza-l80;
      }
    }

    .tab-container {
      padding: 10px 16px;
      border-bottom: 3px transparent solid;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      ::v-deep .v-slide-group__next,
      ::v-deep .v-slide-group__next {
        max-width: 35px;
      }

      &.v-tab {
        color: $marca-0;
        opacity: 0.6333;
        letter-spacing: normal;
      }

      &.v-tab--active {
        color: $marca-0;
        opacity: 0.6333;
        border-bottom: 3px $marca-0-l40 solid;
        background-color: transparent;
        letter-spacing: normal;
      }
    }
    .group-title {
      color: #a3a3a3;
      font-size: 12px;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      margin: 20px 0px 12px 0px;
    }

    .criterio-template {
      text-align: left;
      margin-bottom: 4px;

      ::v-deep .v-card__text {
        height: 28px;
      }

      button {
        padding: 0;
        height: 28px;
        width: 100%;

        .v-card {
          width: 100%;
        }
      }

      .v-btn {
        text-transform: none;
      }
    }
  }
  .title-criterio-details {
    color: $cinza-d20;
    font-size: 18px;
    font-weight: 400;
    line-height: 120%;
    margin: 6px 0px 36px 0px;
  }
}
</style>
